import React from 'react'
import FeatureDocumentation from '../../components/layouts/docsection';
import AddCampaign from "../../images/addcampaign.png"
 
const Campaigns = () => {
  const CampaignsDoc = {
    title: "Campaigns",
    description: "Understand how to set up and manage campaigns for resellers to earn rewards through specific tasks.",
    sections: [
      {
        title: "Overview",
        content: "Campaigns are created to encourage resellers by rewarding them for completing defined tasks. Use campaigns to boost engagement and track reseller performance.",
      },
  
      // Documentation for adding a new campaign
      {
        title: "Add Campaign",
        content: "The 'Add Campaign' section enables you to set up a new campaign by defining its purpose, active dates, and rewards.",
        image: AddCampaign,
        imageAlt: "Add Campaign Dashboard Overview",
        imageCaption: "Figure 1: Detailed view of the Campaign Dashboard interface",
        subsections: [
          {
            title: "Steps to Add a New Campaign",
            content: "Follow these steps to add a new campaign to the platform. Campaigns added can be edited or removed as needed.",
            steps: [
              "Name: Enter a clear and descriptive name for the campaign (e.g., 'Q4 Sales Booster' or 'Top Reseller Challenge').",
              "Campaign Type: Select the type of campaign. Options include:\n - **Marketing Campaign**: Use this to raise awareness or promote specific products.\n - **Leaderboard Campaign**: Aimed at ranking resellers based on performance metrics.",
              "Campaign Text: Provide a brief summary of the campaign. Use this section to explain what resellers can achieve and the rewards they can earn. This text will be visible to resellers, so be clear and motivating.",
              "Campaign ID: Enter a unique identifier for the campaign (e.g., 'CAMP2024Q1'). This ID helps track and manage the campaign in reports and analytics.",
              "Dates: Set the campaign's start and end dates to define its active period. Click on the date fields to select a start date (when the campaign begins) and an end date (when the campaign concludes).",
            ],
          },
        ],
      },
    ],
  };
  
  return (
    <FeatureDocumentation {...CampaignsDoc}/>
  )
}

export default Campaigns;